const baseRoute = '/capacity-planning'

export const CapacityPlanningAreaRoutes = {
  route: baseRoute,
  path: '/',
}
